// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2pSnN","primary":"Button_primary__3m1AO","info":"Button_info__XrQf8","outline":"Button_outline__3owlx"};